import LogRocket from 'logrocket'
import { type PropsWithChildren, useEffect } from 'react'

import { appVersion, logrocketApp } from '@fv/client-core'

import InfoBox from '@/components/InfoBox'
import {
  useAppContext,
  useAppSettings,
  useUserSettings,
} from '@/hooks/settings'

import { useAccountLocations } from '../addresses/useAddress'

const style = { margin: '2rem auto', maxWidth: '11rem' }

export const SessionGate = ({ children }: PropsWithChildren) => {
  const appSettingsQuery = useAppSettings()
  const contextQuery = useAppContext()
  const userSettingsQuery = useUserSettings()
  const locationsQuery = useAccountLocations() // used by onboarding check

  const hasRequiredData =
    appSettingsQuery.isSuccess &&
    contextQuery.isSuccess &&
    userSettingsQuery.isSuccess &&
    locationsQuery.isSuccess

  useEffect(() => {
    const user = contextQuery.data?.user
    if (!logrocketApp || !user) return

    LogRocket.init(`d6lkaq/${logrocketApp}`, {
      rootHostname: 'freightview.com',
      release: appVersion,
    })

    LogRocket.identify(user._id, {
      accountId: user.accountIds[0],
      email: user.email,
      isAdmin: user.isAdmin,
      name: user.firstName + ' ' + user.lastName,
    })
  }, [contextQuery.data?.user])

  return hasRequiredData ? (
    children
  ) : (
    <div style={style}>
      <InfoBox icon="sync">Authenticating</InfoBox>
    </div>
  )
}
